import {
  USER_IS_ACTIVE,
  CREATE_USER,
  FCM_TOKEN,
  NOT_SHOW_AGAIN,
  RESET_PASSWORD_PROFILE,
  SWITCH_MUSUEM_URL,
  USER_DETAILS,
  USER_LIST,
  USER_RESET_PASSWORD,
  POP_RESTRICT,
  USER_DROPDOWN,
  USER_LAST_SCREEN,
} from "../api";
import axiosInstance from "../axiosInstance";

export const createUser = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_USER, props.values)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response.data);
      });
  } catch (error) {}
};

export const listUser = (props) => (onResponse) => {
  try {
    let BASE_URL = USER_LIST + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props?.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props?.sort) {
      BASE_URL += "sort_by=" + props.sort + "&";
    }
    if (props?.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props?.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props?.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props?.is_active) {
      BASE_URL += "is_active=" + props.is_active + "&";
    }
    if (props?.group_id) {
      BASE_URL += "group_id=" + props.group_id + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response.data);
      });
  } catch (error) {}
};

export const getUserDetails = (props) => (onResponse) => {
  try {
    axiosInstance
      .get(USER_DETAILS + "?user=" + props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (error) {}
};
export const resetPasswordProfile = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(RESET_PASSWORD_PROFILE, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response.data);
      });
  } catch (error) {}
};

export const userResetPassword = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(USER_RESET_PASSWORD, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {}
};

export const doNotShowAgainHandler = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(NOT_SHOW_AGAIN, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {}
};

export const museumSwitchHandler = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(SWITCH_MUSUEM_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {}
};
export const useractiveinactivestatus = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(USER_IS_ACTIVE, { user: props })
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {}
};

export const updateFCM = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(FCM_TOKEN, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {}
};

export const popupPreference = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(POP_RESTRICT, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {}
};
export const listUserDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = USER_DROPDOWN + "?";

    if (props?.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props?.transit_approval) {
      BASE_URL += "transit_approval=" + props.transit_approval + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {}
};

export const usedLastScreen = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(USER_LAST_SCREEN, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response.data);
      });
  } catch (error) {}
};
